// extracted by mini-css-extract-plugin
module.exports = {"main_content":"main_content-3N5v8C0v"};